module.exports = __webpack_public_path__ + "img/beaver.939348c0.png";